// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3BbHR","signatureBlock":"Footer_signatureBlock__DW7AX","signature":"Footer_signature__2-Hzr"};